// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"56":"986e0e5f","292":"cdbca750","810":"12c42870","875":"54592b6b"}[chunkId] + ".css";
};